/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 8/02/19.
 */
function ExternalIngestQueueEditorModalComponent(
    this: JS5Object,
    _: JS5Object
) {

    //================//
    // Template Logic //
    //================//

    this.cancel = () => {
        this.dismiss({$value: 'cancel'});
    };

    this.canSave = () => {
        return this.editorForm.$valid && this.editorForm.$dirty;
    };

    this.onSave = () => {
        _.forEach(this.editData, (ingestJob: JS5Object) => {
            ingestJob.priority = this.priority;
        });
        this.close({$value: this.editData});
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.editData = _.cloneDeep(this.resolve.externalIngestJobs);
        this.priority = _.parseInt(this.editData[0].priority);
        if (_.some(this.editData, (ingestJob: JS5Object) => {
            return ingestJob.priority !== this.priority;
        })) {
            this.priority = null;
        }
    };

}

angular
    .module('prism-ui.components')
    .component(
        'externalIngestQueueEditorModal',
        {
            controller: ExternalIngestQueueEditorModalComponent,
            templateUrl: 'components/modal/externalIngest/externalIngestQueueEditorModal/external-ingest-queue-editor-modal-template.html',
            bindings: {
                resolve: '<',
                close: '&',
                dismiss: '&'
            }
        }
    );
